<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <my-global-icon iconName="cross" aria-label="Close" role="button" (click)="hide()"></my-global-icon>
  </div>

  <div class="modal-body">
    <form novalidate [formGroup]="form" (ngSubmit)="report()">

    <div class="row">
      <div class="col-5">

          <label i18n for="reportPredefinedReasons">What is the issue?</label>

          <div class="ms-2 mt-2 d-flex flex-column">
            <ng-container formGroupName="predefinedReasons">

              <div class="form-group" *ngFor="let reason of predefinedReasons">
                <my-peertube-checkbox [inputName]="reason.id" [formControlName]="reason.id" [labelText]="reason.label">
                  <ng-template *ngIf="reason.help" ptTemplate="help">
                    <div [innerHTML]="reason.help"></div>
                  </ng-template>

                  <ng-container *ngIf="reason.description" ngProjectAs="description">
                    <div [innerHTML]="reason.description"></div>
                  </ng-container>
                </my-peertube-checkbox>
              </div>

            </ng-container>
          </div>
      </div>

      <div class="col-7">
        <div i18n class="information">
          Your report will be sent to moderators of {{ currentHost }}<ng-container *ngIf="isRemote()"> and will be forwarded to the comment origin ({{ originHost }}) too</ng-container>.
        </div>

        <div class="form-group">
          <textarea
            i18n-placeholder placeholder="Please describe the issue..." formControlName="reason" ngbAutofocus
            [ngClass]="{ 'input-error': formErrors['reason'] }" class="form-control"
          ></textarea>
          <div *ngIf="formErrors.reason" class="form-error">
            {{ formErrors.reason }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group inputs">
      <input
        type="button" role="button" i18n-value value="Cancel" class="peertube-button grey-button"
        (click)="hide()" (key.enter)="hide()"
      >

      <input type="submit" i18n-value value="Submit" class="peertube-button orange-button" [disabled]="!form.valid">
    </div>

    </form>
  </div>
</ng-template>
